module.exports = __webpack_public_path__ + "img/floppy_white.963aa001.png";